import React, { useEffect, useState } from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

type toastProps = {
    content: {
       text: string;
       setToastHandle: (value: typeToastData) => void;
    };
};

type typeToastData = {
    isVoteSuccess: boolean;
    isShowToast: boolean;
    toastText: string;
};

const Toast = ({ content }: toastProps) => {
    useEffect(() => {
        setTimeout(() => {
            content.setToastHandle({
                isVoteSuccess: false,
                isShowToast: false,
                toastText: ''
            })
        }, 1000);
    }, []);

    return (
        <div className={styles.toastBox}>
            <div className={styles.toast}>
                {content.text}
            </div>
        </div>
    );
};

export default errorBoundary(Toast);
